import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class DedicateddevteamService { 

    constructor(private http: HttpClient) { }

    getdedicatedteamService() {
        return this.http.get<any[]>(`${environment.apiUrl}get_dedicated_dev_team`);
    }    	    
}
